'use client';
import Link from 'next/link';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import Logo from '../logo/logo';
import LinkWrapper from '../link-wrapper/link-wrapper';
import { Icon } from '@fm-nx/svg';
import classNames from 'classnames';
const Disclosure = dynamic(() => import('@headlessui/react').then((mod) => ({ default: mod.Disclosure })), {
    ssr: false,
});
const DisclosureButton = dynamic(() => import('@headlessui/react').then((mod) => ({ default: mod.DisclosureButton })), {
    ssr: false,
});

type MainNavMobilePropTypes = {
    variant?: 'light' | 'dark' | 'dark-transparent';
};

export const MainNavMobile = (props: MainNavMobilePropTypes) => {
    const { variant = 'light' } = props;
    const isDarkVariant = variant === 'dark' || variant === 'dark-transparent';
    const hasBackground = variant === 'dark';
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSearchOpen] = useState(false);

    const isOpen = isSearchOpen || isMenuOpen;
    const isDark = isSearchOpen || isMenuOpen || isDarkVariant;

    const toggleMenu = () => {
        if (typeof window !== 'undefined') {
            if (!isMenuOpen) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        }
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <Disclosure>
            <header
                className={classNames(`absolute top-0 z-50 w-full transition-all`, {
                    'bg-gray-900 h-screen': isOpen,
                })}
            >
                <div className="w-full mx-auto max-w-container">
                    <nav className="">
                        {/* mobile header */}
                        <div
                            className={classNames(`z-50 w-full`, {
                                'bg-gray-900': hasBackground,
                            })}
                        >
                            <div className={`py-6 mx-6`}>
                                <div className="grid grid-cols-4 lg:grid-cols-14">
                                    <div className="col-span-2 lg:col-span-3 lg:col-start-2">
                                        <Link href="/" className="block group">
                                            <Logo mode={isDark ? 'light' : 'dark'} />
                                        </Link>
                                    </div>
                                    <div className="col-span-2 lg:hidden">
                                        {/* Mobile menu button */}
                                        <div className="flex items-center justify-end h-full">
                                            <DisclosureButton
                                                onClick={() => toggleMenu()}
                                                className="flex items-center justify-end"
                                            >
                                                {!isOpen && (
                                                    <>
                                                        <span className="sr-only">Open main menu</span>
                                                        <Icon
                                                            name="menu"
                                                            color={isDark ? 'white' : 'black'}
                                                            size="xl"
                                                        />
                                                    </>
                                                )}
                                                {isOpen && (
                                                    <>
                                                        <span className="sr-only">Close main menu</span>
                                                        <Icon
                                                            name="close"
                                                            color={isDark ? 'white' : 'black'}
                                                            size="xl"
                                                        />
                                                    </>
                                                )}
                                            </DisclosureButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* mobile nav */}
                        <div className={`${isOpen ? 'block' : 'hidden'}`}>
                            <div className="mx-6 my-6 space-y-6">
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/expertise"
                                        className="text-white h4 border-b-out"
                                    >
                                        Expertise
                                    </LinkWrapper>
                                </div>
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/case-studies"
                                        className="text-white h4 border-b-out"
                                    >
                                        Case Studies
                                    </LinkWrapper>
                                </div>
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/about"
                                        className="text-white h4 border-b-out"
                                    >
                                        About
                                    </LinkWrapper>
                                </div>
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/partners-and-platforms"
                                        className="text-white h4 border-b-out"
                                    >
                                        Platforms & Partners
                                    </LinkWrapper>
                                </div>
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/about/journal"
                                        className="text-white h4 border-b-out"
                                    >
                                        Journal
                                    </LinkWrapper>
                                </div>
                                <div>
                                    <LinkWrapper
                                        onClick={() => toggleMenu()}
                                        href="/contact"
                                        className="text-white h4 border-b-out"
                                    >
                                        Contact
                                    </LinkWrapper>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        </Disclosure>
    );
};

export default MainNavMobile;
